import "./Accessibility.module.css";
import Header from "@/reusable_sections/Header";
import Accessibility from "./sections/Accessibility";
import Footer from "@/reusable_sections/Footer";
export default function AccessibilityPage() {
  return <div>
      <Header />
      <Accessibility />
      <Footer />
    </div>;
}